module.exports = __webpack_public_path__ + "media/newstyle/images/pocket-white-afe701336ebb80496cbb89dcd8bedb41.svg";